import initCarousel from "./carousel";

export default function initModal() {
  const buttons = document.querySelectorAll(".js-open-modal");
  const modal = document.getElementById("modal");
  const content = document.getElementById("modal__content");
  const closeBtn = document.querySelector(".js-close");

  if (!buttons.length || !modal || !content) return;

  let scrollY = 0;

  const lockScroll = () => {
    const scrollbarWidth =
      window.innerWidth - document.documentElement.clientWidth;
    document.body.style.paddingRight = `${scrollbarWidth}px`;
    document.body.classList.add("is-lock");
  };

  const unlockScroll = () => {
    document.body.classList.remove("is-lock");
    document.body.style.paddingRight = "";
  };

  const openModal = async (postId) => {
    const res = await fetch(`${ajaxObject.restUrl}${postId}`);

    const data = await res.json();
    const html = data.html;

    content.innerHTML = html;

    initCarousel();

    modal.classList.add("is-open");

    lockScroll();
  };

  const closeModal = () => {
    modal.classList.remove("is-open");

    // アニメーション終了後に中身クリア（任意）
    setTimeout(() => {
      content.innerHTML = "";
    }, 300);

    unlockScroll();
  };

  // 開く
  buttons.forEach((btn) => {
    btn.addEventListener("click", (e) => {
      e.preventDefault();
      openModal(btn.dataset.id);
    });
  });

  // 閉じるボタン
  closeBtn?.addEventListener("click", closeModal);

  // 背景クリックで閉じる
  modal.addEventListener("click", (e) => {
    if (e.target === modal) {
      closeModal();
    }
  });

  // Escキー
  document.addEventListener("keydown", (e) => {
    if (e.key === "Escape" && modal.classList.contains("is-open")) {
      closeModal();
    }
  });
}
